import React from "react";
import { Link } from "react-router-dom";
import axios from 'axios';

import heroimg from "../assets/images/Sign In/Hero-bg.jpg";
import btnsrow from "../assets/images/icons/button-arrow.svg";
import backimg from "../assets/images/Sign In/Back.png";
import toast from 'toasted-notes' 
import 'toasted-notes/src/styles.css';

class Signin extends React.Component {
  constructor() {
    super();
    this.state = {
      email: '',
      password: '',
      error: '',
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeEmail = this.handleChangeEmail.bind(this);
    this.handleChangePassword = this.handleChangePassword.bind(this);
  }

  handleChangeEmail(event) {
    this.setState({email: event.target.value});
  }

  handleChangePassword(event) {
    this.setState({password: event.target.value});
  }

  handleSubmit(event) {
    event.preventDefault();
    
    axios.post(`${process.env.REACT_APP_BASE_URL}/oauth/token`, { email: this.state.email, password: this.state.password, grant_type: 'password' })
      .then((response) => {
        if(response.data.user) {
          sessionStorage.setItem('user', JSON.stringify(response.data.user));
          sessionStorage.setItem('access_token', response.data.access_token);
          toast.notify('Sign in Successfull');
          if(!sessionStorage.getItem('return-url')) {
            this.props.history.push('/');
          }
          else {
            this.props.history.push(sessionStorage.getItem('return-url'));
            sessionStorage.removeItem('return-url')
          }
        }
        else {
          this.setState({ error: response.data.error });
        }
        // const data = response.data;
        // if(data.status === true) {
        //   this.props.history.push('/signin');
        // }
        // else {
        //   this.setState({ error: data.message });
        // }
      })
      .catch((error) => {
        this.setState({ error: 'Invalid Email or Password' });
      });
  }

  render() {
    return (
      <section id="signin-section" className="section fix signin-section">
        <div className="container-fluid">
          <Link className="back-img" to="/">
            <img src={backimg} alt="back image" />
          </Link>
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12" id="signin_mob-padd">
              <div className="singin-pass-form-details">
                <h2 className="projetc_ttls">
                  <Link className="main_logohm" to="/">
                  EXCLUSIVE GULETS{" "}
                  </Link>
                </h2>
                <p className="title">Sign In</p>
                <h2 className="main-title">
                  Please log in to request a quotation or manage your account
                </h2>
                <p className="subline-text">
                  Sign in below to access your account.
                </p>
                {this.state.error === '' ? '' : <p className="title">{this.state.error}</p>}
                <form onSubmit={this.handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="InputEmail1">Email:</label>
                    <input
                      type="email"
                      className="form-control"
                      id="InputEmail1"
                      aria-describedby="emailHelp"
                      placeholder="your@email.com"
                      value={this.state.email}
                      onChange={this.handleChangeEmail}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="InputEmail1">Password:</label>
                    <input
                      type="password"
                      className="form-control"
                      id="InputEmail1"
                      aria-describedby="emailHelp"
                      placeholder="Enter 6 chracter or more"
                      value={this.state.password}
                      onChange={this.handleChangePassword}
                      required
                    />
                  </div>
                  <div className="forget-btn-div">
                    <button type="submit" className="btn btn-theme btn-primary">
                      Sign in
                      <img
                        src={btnsrow}
                        className="img-responsive"
                        alt="arrow"
                      />
                    </button>
                  </div>
                  <p className="creat-acc-link">
                    <Link className="creat_link" to="/signup">
                      Don't have an account. Create one here.
                    </Link>
                  </p>
                  <p className="forget-pass-link">
                    <a className="creat_link" target="_blank" href={process.env.REACT_APP_BASE_URL+'/users/password/new'}>
                      Forgot your password.
                    </a>
                  </p>
                </form>
              </div>
            </div>
            <div
              className="col-lg-6 col-md-6 col-sm-12 no-padding"
              id="mobile_hidesignin"
            >
              <div className="rightside-image signin-right">
                <img
                  id="signimgs"
                  src={heroimg}
                  className="img-responsive sign_img"
                  alt="Hero BG"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
export default Signin;
